import { render, staticRenderFns } from "./event-edit.vue?vue&type=template&id=0faaf978&scoped=true"
import script from "./event-edit.vue?vue&type=script&lang=js"
export * from "./event-edit.vue?vue&type=script&lang=js"
import style0 from "./event-edit.vue?vue&type=style&index=0&id=0faaf978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faaf978",
  null
  
)

export default component.exports